"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tile = function Tile(props) {
  //render
  var modalClasses = (0, _classnames["default"])("tile-component");
  var TitleTag = props.titleTag;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "imageContainer",
    "data-value": props.value,
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("object", {
    className: "tileImg",
    data: props.imgUrl,
    type: "image/png",
    alt: props.alt
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "asset-glyph-images"
  }))), props.overlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "imageOverlay"
  }, /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
    right: [/*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: props.overlay.iconName ? props.overlay.iconName : "icon-brick-editor",
      type: "framed-icon"
    }), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      className: "checkmark",
      name: "micro-glyph-checkmark",
      type: "framed-glyph"
    })]
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tileDescription"
  }, props.title && /*#__PURE__*/_react["default"].createElement(TitleTag, null, props.title), props.desc && /*#__PURE__*/_react["default"].createElement("p", {
    className: "mice"
  }, props.desc), props.label && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mice label"
  }, props.label)));
};

Tile.propTypes = {
  imgUrl: _propTypes["default"].string,
  overlay: _propTypes["default"].shape({
    iconName: _propTypes["default"].string,
    actions: _propTypes["default"].shape({
      onClick: _propTypes["default"].func,
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
    })
  }),
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  desc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  label: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  value: _propTypes["default"].string,
  // onclick data value
  titleTag: _propTypes["default"].oneOf(["h2", "h3", "h4", "h5"])
};
Tile.defaultProps = {
  titleTag: "h5"
};
var _default = Tile;
exports["default"] = _default;